(function Module() {
	'use strict';

	mySynch.factory('WeatherFactory', [
		'$http',
		'$q',
		'clientLoggerService',
		function WeatherFactory($http, $q, log) {
			return {
				get: function getWeather(zip, unitsName) {
					var deferred = $q.defer();

					$http.get(mySynchModules.config.weather.api +
						'?zip=' + zip +
						'&units=' + unitsName +
						'&APPID=' + mySynchModules.config.weather.apiKey
					).success(function getWeatherSuccess(data) {
						deferred.resolve(data);
					}).error(function getWeatherError(err) {
						log.error('error retrieving markets');
						deferred.reject(err);
					});

					return deferred.promise;
				}
			};
		}
	]);
})();
